import ResizeObserver from 'resize-observer-polyfill';
import utils from '@/_modules/utils';
import gnav from '@/_modules/common/gnav';
import alertModal from '@/_modules/common/alertModal';
import footer from '@/_modules/common/footer';
import loading from '@/_modules/common/loading';

export default class pageEvent {
  constructor() {
    this.getHeight100();
    this.winH = 0;
    this.conH = 0;

    loading.once();
    gnav.once();
    footer.once();
    alertModal.once();

    this.init();
  }

  init() {
    this.resizeObserver = new ResizeObserver(this.resize.bind(this));
    this.resizeObserver.observe(document.getElementById('c-container'));
  }

  start() {
    gnav.start();
    alertModal.start();
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  resize(entries) {
    gnav.resize();
    footer.resize();
  }

  scroll(e) {
    let scrollY = scrollY = utils.getScrollTop();
  }
}
